// This file was auto-generated by Fern from our API Definition.
/**
 * The connection state of one integration, derived per the design's state
 * machine. ``ready`` reuses an existing connection; the other two need a human.
 */
export const ToolConnectionState = {
    Ready: "ready",
    NeedsAuth: "needs_auth",
    NeedsInput: "needs_input",
};
